import * as React from 'react'
import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'
import media from '../../../services/generateMediaQueries'
import Background from '../../../assets/img/wifi-header.webp'
import Icon from '../../ui/Icon/Icon'

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    top: 0;
    right: 0;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
  `}
`

const ModalContentWrapper = styled.div`
  overflow: auto;
  max-height: 100vh;
  width: 100%;
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: #ffffff;
  border: 0;
  top: 15px;
  right: 15px;
  font-size: 25px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 100%;
  outline: none;

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const ModalContent = styled.div`
  position: relative;
  margin: 3rem auto;
  width: 325px;
  min-height: 400px;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;

  ${media.lessThan('small')`
    margin: 0;
    height: 100%;
    width: 100%;
    border-radius: 0;
  `}
`

const Content = styled.div``

const Header = styled.img`
  width: 100%;
`

const Title = styled.h3`
  color: var(--color-primary);
  font-size: 1.5rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.5625rem;
  text-align: center;
  margin-top: 3rem;
  position: relative;
  z-index: 1;
`

const Description = styled.p`
  font-size: 0.875rem;
  letter-spacing: 0.1px;
  line-height: 1.3125rem;
  padding: 0 1.6875rem;
  text-align: center;
  margin-bottom: ${props => (props.isMaintenance ? '5rem' : '2rem')};
`

const ConnectionSteps = styled.div`
  text-align: initial;
`

const List = styled.ul`
  padding-inline-start: 1rem;
  li {
    margin-bottom: 1rem;
  }
`

const overlay = {
  zIndex: 10000,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function WifiModal(props) {
  const {
    show,
    onClose,
    zIndex,
    shouldCloseOnOverlayClick,
    description,
    status,
    ...restProps
  } = props
  return (
    <StyledReactModal
      isOpen={show}
      style={{
        overlay: {
          ...overlay,
          ...(zIndex ? { zIndex } : {}),
        },
        content,
      }}
      onRequestClose={onClose}
      closeTimeoutMS={150}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
      {...restProps}
    >
      <ModalContentWrapper>
        <ModalContent>
          <DefaultCloseButton zIndex={zIndex} onClick={onClose}>
            <Icon name="x" />
          </DefaultCloseButton>
          <Content>
            <Header src={Background} alt="Be Right Back" />
            {status === 3 ? (
              <>
                <Title>Be Right Back</Title>
                <Description isMaintenance>{description}</Description>
              </>
            ) : (
              <Description>
                <ConnectionSteps>
                  How to connect:
                  <List>
                    <li>
                      Go to your WiFi settings and connect to
                      @ZingAtAyalaMallsWiFi network.
                    </li>
                    <li>
                      The Zing WiFi portal will pop up. Open your phone browser
                      if the portal does not show.
                    </li>
                    <li>
                      Enter your mobile number and wait for the verification
                      code sent via SMS.
                    </li>
                    <li>Activate your free Zing WiFi and start surfing!</li>
                  </List>
                </ConnectionSteps>
              </Description>
            )}
          </Content>
        </ModalContent>
      </ModalContentWrapper>
    </StyledReactModal>
  )
}

WifiModal.defaultProps = {
  // TODO: specify default props
}

WifiModal.propTypes = {
  // TODO: specify prop types
}

export default WifiModal
